import type { VendorUserRole } from 'library/constants'
import { createContext, useContext } from 'react'

import type { CurrencyInfo, VendorRequestInfoDTO } from '@leanpay/models'

export interface AppStateProps {
    isAuthenticated: boolean
    progress: number
    vendorRequestInfo?: VendorRequestInfoDTO
    currencyInfo?: CurrencyInfo
    sessionInfoLoading?: boolean
    isAppLoading?: boolean
    userRoles?: VendorUserRole[]
    setIsAuthenticated: (value: boolean) => void
    setProgress: (value: number) => void
    setIsAppLoading: (value: boolean) => void
    setUserRoles: (value: VendorUserRole[]) => void
}

const AppContext = createContext<AppStateProps | null>({
    isAuthenticated: false,
    progress: 0,
    vendorRequestInfo: undefined,
    currencyInfo: undefined,
    sessionInfoLoading: false,
    isAppLoading: false,
    userRoles: [],
    setIsAppLoading: () => {
        throw new Error('setIsAppLoading() not implemented')
    },

    setIsAuthenticated: () => {
        throw new Error('setIsAuthenticated() not implemented')
    },
    setProgress: () => {
        throw new Error('setProgress() not implemented')
    },
    setUserRoles: () => {
        throw new Error('setUserRoles() not implemented')
    },
})

export const useAppStore = () => {
    const ctx = useContext(AppContext)

    if (!ctx) {
        throw new Error('AppContext can be used only within AppProvider')
    }

    return ctx
}

export default AppContext
